"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _globals = _interopRequireDefault(require("@insided/shared/utils/globals"));

var _EmptyPage = _interopRequireDefault(require("../../preact-components/empty-page/EmptyPage"));

var errors = {
  400: {
    header: "You've just sent a bad request",
    text: 'There was a problem with your request. Please try again.'
  },
  403: {
    header: 'You shall not pass',
    text: "We're sorry, but you do not have permission to access this page."
  },
  404: {
    header: 'Whoops! Page not found',
    text: (0, _preact.h)("div", null, (0, _preact.h)("p", null, "Sorry, the page you are looking for might have been removed, or is temporarily unavailable."), (0, _preact.h)("p", null, "Did you come here through our website?"))
  },
  500: {
    header: "Oops! There's an internal server error.",
    text: "Don't worry, it's not you - it's us. Sorry about that.\n Please try again in a few minutes."
  }
};

var ErrorPage = function ErrorPage(_ref) {
  var code = _ref.code,
      buttonText = _ref.buttonText,
      buttonLink = _ref.buttonLink;
  var error = errors[code];
  var text = buttonText !== null && buttonText !== void 0 ? buttonText : 'Back to homepage';
  var link = buttonLink !== null && buttonLink !== void 0 ? buttonLink : '/';
  if (!error) return 'Sorry, this page is not available';
  return (0, _preact.h)(_EmptyPage.default, (0, _extends2.default)({
    fullHeight: true,
    img_src: "".concat((0, _globals.default)('basePath'), "images/errors/").concat(code, ".png"),
    button: {
      link: link,
      text: text
    }
  }, error));
};

var _default = ErrorPage;
exports.default = _default;